import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useIntake } from '../../context/IntakeContext';
import { Input } from '../ui/Input';
import { RadioGroup } from '../ui/RadioGroup';
import { MascotPanel } from '../ui/MascotPanel';
import { Button } from '../ui/Button';
import { PlusIcon, Trash2Icon } from 'lucide-react';
export function Step4Company() {
  const {
    data,
    updateData
  } = useIntake();
  const addLocation = () => {
    const newLocation = {
      id: Date.now().toString(),
      name: '',
      street: '',
      postcode: '',
      city: '',
      province: '',
      country: 'Nederland',
      phone: '',
      email: '',
      hours: '',
      showOnWebsite: 'yes',
      needsPage: false,
      services: ''
    };
    updateData({
      locations: [...data.locations, newLocation]
    });
  };
  const removeLocation = (id: string) => {
    updateData({
      locations: data.locations.filter(l => l.id !== id)
    });
  };
  const updateLocation = (id: string, field: string, value: any) => {
    updateData({
      locations: data.locations.map(l => l.id === id ? {
        ...l,
        [field]: value
      } : l)
    });
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} className="max-w-3xl mx-auto space-y-8" data-id="element-315">
      <MascotPanel message="Tijd voor de officiële gegevens. Deze informatie gebruiken we voor de contactpagina, footer en eventuele juridische documenten op uw nieuwe website." data-id="element-316" />

      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8" data-id="element-317">
        <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-318">
          Bedrijfsgegevens
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-319">
          <Input label="Bedrijfsnaam (Statutair)" value={data.companyName} onChange={e => updateData({
          companyName: e.target.value
        })} data-id="element-320" />
          <Input label="Handelsnaam (indien anders)" value={data.tradeName} onChange={e => updateData({
          tradeName: e.target.value
        })} data-id="element-321" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-322">
          <Input label="KVK Nummer" value={data.cocNumber} onChange={e => updateData({
          cocNumber: e.target.value
        })} data-id="element-323" />
          <Input label="BTW Nummer" value={data.vatNumber} onChange={e => updateData({
          vatNumber: e.target.value
        })} data-id="element-324" />
        </div>

        <div className="mb-6" data-id="element-325">
          <h3 className="text-lg font-bold text-gray-900 mb-4" data-id="element-326">
            Hoofdvestiging adres
          </h3>
          <p className="text-sm text-gray-500 mb-4" data-id="element-327">
            Vul uw straat en huisnummer in — de overige velden worden waar
            mogelijk automatisch aangevuld.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-328">
            <Input label="Straat + Huisnummer" placeholder="Bijv. Keizersgracht 123" value={data.mainStreet} onChange={e => updateData({
            mainStreet: e.target.value
          })} data-id="element-329" />
            <Input label="Postcode" placeholder="1234 AB" value={data.mainPostcode} onChange={e => updateData({
            mainPostcode: e.target.value
          })} data-id="element-330" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-331">
            <Input label="Stad" placeholder="Amsterdam" value={data.mainCity} onChange={e => updateData({
            mainCity: e.target.value
          })} data-id="element-332" />
            <Input label="Provincie" placeholder="Noord-Holland" value={data.mainProvince} onChange={e => updateData({
            mainProvince: e.target.value
          })} data-id="element-333" />
            <Input label="Land" value={data.mainCountry} onChange={e => updateData({
            mainCountry: e.target.value
          })} data-id="element-334" />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-335">
          <Input label="Algemeen telefoonnummer" value={data.companyPhone} onChange={e => updateData({
          companyPhone: e.target.value
        })} data-id="element-336" />
          <Input label="Algemeen e-mailadres" type="email" value={data.companyEmail} onChange={e => updateData({
          companyEmail: e.target.value
        })} data-id="element-337" />
        </div>

        <div className="mb-8" data-id="element-338">
          <Input label="Huidige website URL (indien van toepassing)" placeholder="https://www.uwbedrijf.nl" value={data.existingWebsiteUrl} onChange={e => updateData({
          existingWebsiteUrl: e.target.value
        })} data-id="element-339" />
        </div>

        <div className="pt-8 border-t border-gray-100" data-id="element-340">
          <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-341">Locaties</h3>

          <div className="mb-6" data-id="element-342">
            <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-343">
              Heeft u meerdere locaties?
            </label>
            <RadioGroup columns={2} value={data.multipleLocations} onChange={val => updateData({
            multipleLocations: val
          })} options={[{
            value: 'yes',
            label: 'Ja, meerdere locaties'
          }, {
            value: 'no',
            label: 'Nee, één locatie'
          }]} data-id="element-344" />
          </div>

          <AnimatePresence data-id="element-345">
            {data.multipleLocations === 'yes' && <motion.div initial={{
            opacity: 0,
            height: 0
          }} animate={{
            opacity: 1,
            height: 'auto'
          }} exit={{
            opacity: 0,
            height: 0
          }} className="overflow-hidden space-y-6" data-id="element-346">
                <div data-id="element-347">
                  <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-348">
                    Hoe wilt u de locaties op de website verwerken?
                  </label>
                  <RadioGroup columns={1} value={data.locationStrategy} onChange={val => updateData({
                locationStrategy: val
              })} options={[{
                value: 'separate_website',
                label: 'Een aparte website per locatie'
              }, {
                value: 'separate_page',
                label: 'Een aparte pagina per locatie op dezelfde website'
              }, {
                value: 'mention_only',
                label: 'Eén website met alleen benoeming van de locaties (bijv. in de footer)'
              }, {
                value: 'no_mention',
                label: 'Geen benoeming van specifieke locaties'
              }, {
                value: 'specific_only',
                label: 'Alleen specifieke locaties benoemen, andere niet'
              }]} data-id="element-349" />
                </div>

                <div className="bg-blue-50 p-4 rounded-xl border border-blue-100" data-id="element-350">
                  <p className="text-sm text-blue-800" data-id="element-351">
                    <strong data-id="element-352">Tip voor gebruikersgemak:</strong> Voeg uw locaties
                    hieronder toe. Wij denken graag met u mee over een handige
                    zoekfunctie of interactieve kaart voor uw bezoekers.
                  </p>
                </div>

                <div className="space-y-6" data-id="element-353">
                  <h4 className="font-bold text-gray-900" data-id="element-354">
                    Locaties toevoegen
                  </h4>

                  {data.locations.map((loc, index) => <motion.div key={loc.id} initial={{
                opacity: 0,
                y: 10
              }} animate={{
                opacity: 1,
                y: 0
              }} className="p-6 bg-gray-50 rounded-2xl border border-gray-200 relative space-y-4" data-id="element-355">
                      <button onClick={() => removeLocation(loc.id)} className="absolute top-4 right-4 p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-full transition-colors" data-id="element-356">
                        <Trash2Icon className="w-5 h-5" data-id="element-357" />
                      </button>

                      <h5 className="font-semibold text-gray-900" data-id="element-358">
                        Locatie {index + 1}
                      </h5>

                      <Input label="Naam locatie (bijv. Vestiging Amsterdam)" value={loc.name} onChange={e => updateLocation(loc.id, 'name', e.target.value)} data-id="element-359" />

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-360">
                        <Input label="Straat + Huisnummer" value={loc.street} onChange={e => updateLocation(loc.id, 'street', e.target.value)} data-id="element-361" />
                        <Input label="Postcode" value={loc.postcode} onChange={e => updateLocation(loc.id, 'postcode', e.target.value)} data-id="element-362" />
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-363">
                        <Input label="Stad" value={loc.city} onChange={e => updateLocation(loc.id, 'city', e.target.value)} data-id="element-364" />
                        <Input label="Provincie" value={loc.province} onChange={e => updateLocation(loc.id, 'province', e.target.value)} data-id="element-365" />
                        <Input label="Land" value={loc.country} onChange={e => updateLocation(loc.id, 'country', e.target.value)} data-id="element-366" />
                      </div>

                      {data.locationStrategy === 'specific_only' && <div className="pt-2" data-id="element-367">
                          <label className="block text-sm font-semibold text-gray-900 mb-2" data-id="element-368">
                            Deze locatie tonen op de website?
                          </label>
                          <RadioGroup columns={2} value={loc.showOnWebsite} onChange={val => updateLocation(loc.id, 'showOnWebsite', val)} options={[{
                    value: 'yes',
                    label: 'Ja, tonen'
                  }, {
                    value: 'no',
                    label: 'Nee, verbergen'
                  }]} data-id="element-369" />
                        </div>}
                    </motion.div>)}

                  <Button variant="outline" onClick={addLocation} className="w-full border-dashed" data-id="element-370">
                    <PlusIcon className="w-5 h-5 mr-2" data-id="element-371" />
                    Locatie toevoegen
                  </Button>
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>
      </div>
    </motion.div>;
}